export default {
  computed: {
    $tenantTimezone() {
      return this.$store.state.setting.organizationSettings.timezone
    },
  }
}